import { create } from 'zustand';
import MuvikaService from '../services/muvika';
import { generateId } from '../services/random';
import accountStore from './account';
import ExternalViewCommands from '../services/external';
import IntervalService from '../services/intervals';
import messageStore from './message';
import playerStore from './player';
import TR from './../Trans';
import settingsStore from './settings';
import { sortBySmartQ } from '../services/smartq';
import { subscribeWithSelector } from 'zustand/middleware';

const maxPlayQueueSize = 2200;

const initialState = {
  isSet: false,
  isWaiting: false,
  isOn: false,
  totalCount: 0,
  tabValue: 0,
  history: null,
  countdown: 0,
  currentPlayList: null,
  playQueue: null,
  currentPosition: 0,
  currentPerformance: null,
  nextPerformance: null,
  playQueueDuration: 0,
  performanceToBeChanged: null,
  playLists: null,
  songbookIds: [],
  playQueueTrackList: null,
  currentTitle: null,
  nextSingerTitle: null,
  isFirstPerformance: null,
  mySongRequestsDelivered: null,
  mySongRequestsPending: null,
  songbookPerformancesToBeDeleted: {}
};

const performanceStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setSongbookPerformanceToBeDeleted: (performance) => {
    let songbookPerformancesToBeDeleted = get().songbookPerformancesToBeDeleted;
    songbookPerformancesToBeDeleted[performance.unique_id] = performance;
    set({ songbookPerformancesToBeDeleted: songbookPerformancesToBeDeleted });
  },
  removeSongbookPerformanceFromToBeDeleted: (performance) => {
    let songbookPerformancesToBeDeleted = get().songbookPerformancesToBeDeleted;
    delete songbookPerformancesToBeDeleted[performance.unique_id];
    set({ songbookPerformancesToBeDeleted: songbookPerformancesToBeDeleted });
  },
  setCountdown: (countdown) => {


    set({ countdown: countdown });
  },
  setIsFirstPerformance: (isFirstPerformance) => {


    set({ isFirstPerformance: isFirstPerformance });
  },
  setNextPerformance: (nextPerformance) => {


    set({ nextPerformance: nextPerformance });
  },
  setCurrentPerformance: (performance) => {


    set({ currentPerformance: performance });
  },
  setCurrentTitle: (title) => {


    set({ currentTitle: title });
  },
  setPlayQueueTrackList: (list) => {


    set({ playQueueTrackList: list });
  },
  setNextSingerTitle: (title) => {


    set({ nextSingerTitle: title });
  },
  clearSmartQ: (sessionToken) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        for (let i = 0; i < playQueue.items.length; i++) {
          playQueue.items[i] = get().setManual(playQueue.items[i], false);
        }
        MuvikaService.setPlayList(sessionToken, playQueue)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              set({ playQueue: { ...playQueue } });
            }
          })
          .catch(function () { });
      }
    }
  },
  editCurrentPerformanceSinger: (profileId, newName, newGender, newEmail) => {


    let currentPerformance = get().currentPerformance;
    if (currentPerformance) {
      if (currentPerformance.profile.id == profileId) {
        currentPerformance.profile.name = newName;
        currentPerformance.profile.gender = newGender;
        currentPerformance.profile.email = newEmail;
        set({ currentPerformance: { ...currentPerformance } });
      }
    }
  },
  editNextPerformanceSinger: (profileId, newName, newGender, newEmail) => {


    let nextPerformance = get().nextPerformance;
    if (nextPerformance) {
      if (nextPerformance.profile.id == profileId) {
        nextPerformance.profile.name = newName;
        nextPerformance.profile.gender = newGender;
        nextPerformance.profile.email = newEmail;
        set({ nextPerformance: { ...nextPerformance } });
      }
    }
  },
  editSingerPlayQueue: (profileId, newName, newGender, newEmail) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        for (let i = 0; i < playQueue.items.length; i++) {
          if (playQueue.items[i].profile.id == profileId) {
            let pqItem = {...playQueue.items[i]}
            pqItem.profile.name = newName;
            pqItem.profile.gender = newGender;
            pqItem.profile.email = newEmail;
            playQueue.items[i]=pqItem;
          }
        }
        set({ playQueue: { ...playQueue } });
      }
    }
  },
  editSingerPlayLists: (profileId, newName, newGender, newEmail) => {
    let playLists = get().playLists;
    let newPlayLists = [];
    if (playLists) {
      for (let i = 0; i < playLists.length; i++) {
        let playList = playLists[i];
        for (let i = 0; i < playList.items.length; i++) {
          if (playList.items[i].profile.id == profileId) {
            let pqItem = {...playList.items[i]}
            pqItem.profile.name = newName;
            pqItem.profile.gender = newGender;
            pqItem.profile.email = newEmail;
            playList.items[i]=pqItem;
          }
        }
        newPlayLists.push(playList);
      }
      set({ playLists: [...newPlayLists] });
    }
  },
  editSinger: (profileId, newName, newGender, newEmail) => {
    get().editCurrentPerformanceSinger(profileId, newName, newGender, newEmail);
    get().editNextPerformanceSinger(profileId, newName, newGender, newEmail);
    get().editSingerPlayQueue(profileId, newName, newGender, newEmail);
    get().editSingerPlayLists(profileId, newName, newGender, newEmail);
  },
  smartQRestore: (sessionToken, performanceId) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let playQueueIndex = playQueue.items.findIndex(x => x.unique_id == performanceId);
        if (playQueueIndex != -1) {
          playQueue.items[playQueueIndex] = get().setManual(playQueue.items[playQueueIndex], false);
          MuvikaService.setPlayList(sessionToken, playQueue)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                set({ playQueue: { ...playQueue } });
              }
            })
            .catch(function () { });
        }
      }
    }
  },
  sortBySmartQ: (sessionToken) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      playQueue = sortBySmartQ(playQueue, get().history);
      let duration = 0;
      for (let i = 0; i < playQueue.items.length; i++) {
        playQueue.items[i].position = i;
        playQueue.items[i].incoming = duration;
        duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
      }
      set({ playQueueDuration: duration });
      MuvikaService.setPlayList(sessionToken, playQueue)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            set({ playQueue: { ...playQueue } });
          }
        })
        .catch(function () { });
    }
  },
  savePlayQueue: (sessionToken, playListName) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let newPlayQueueItems = [...playQueue.items];
        newPlayQueueItems.forEach(item => {
          if (typeof item.flags === "string") {
            item.flags = item.flags.replace("track_changed", "");
          }
        });
        MuvikaService.savePlayQueue(sessionToken, playListName, newPlayQueueItems)
          .then(function (res) {
            //console.log(res);
            if (res.data.error) {
              let playLists = get().playLists;
              if (playLists) {
                let playListIndex = playLists.findIndex(x => x.name === playListName);
                if (playListIndex != -1) {
                  messageStore.getState().setError(sessionToken, res.data.error.code, TR.cm_same_playlist_exists_already);
                } else {
                  messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                }
              } else {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            } else {
              messageStore.getState().setMessage(sessionToken, TR.cm_playlist_saved);
              get().getPlayLists(sessionToken);
            }
          })
          .catch(function () { });
      }
    }
  },
  copyPlayList: (sessionToken, playList, playListName) => {


    MuvikaService.savePlayList(sessionToken, 0, playListName, playList.items)
      .then(function (res) {
        if (res.data.error) {
          let playLists = get().playLists;
          if (playLists) {
            let playListIndex = playLists.findIndex(x => x.name === playListName);
            if (playListIndex != -1) {
              messageStore.getState().setError(sessionToken, res.data.error.code, TR.cm_same_playlist_exists_already);
            } else {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            }
          }
        } else {
          messageStore.getState().setMessage(sessionToken, TR.cm_playlist_saved);
          get().getPlayLists(sessionToken);
        }
      })
      .catch(function () { });
  },
  savePlayList: (sessionToken, playListId, playListName) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let newPlayQueueItems = [...playQueue.items];
        newPlayQueueItems.forEach(item => {
          if (typeof item.flags === "string") {
            item.flags = item.flags.replace("track_changed", "");
          }
        });
        MuvikaService.savePlayList(sessionToken, playListId, playListName, newPlayQueueItems)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              messageStore.getState().setMessage(sessionToken, TR.cm_playlist_saved);
              get().getPlayLists(sessionToken);
            }
          })
          .catch(function () { });
      }
    }
  },
  changePlayListName: (sessionToken, playListName, playList) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.name === playListName);
      if (playListIndex != -1) {
        messageStore.getState().setError(sessionToken, 0, TR.cm_same_playlist_exists_already);
      } else {
        MuvikaService.editPlayList(sessionToken, playListName, playList)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              let playLists = get().playLists;
              if (playLists) {
                let playListIndex = playLists.findIndex(x => x.id == playList.id);
                if (playListIndex != -1) {
                  playLists[playListIndex].name = playListName;
                  set({ playLists: [...playLists] });
                  messageStore.getState().setMessage(sessionToken, TR.cm_playlist_saved);
                }
              }
            }
          })
          .catch(function () { });
      }
    }
  },
  getMySongRequestsDelivered: (sessionToken) => {


    MuvikaService.getMySongRequests(sessionToken, "delivered")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          set({ mySongRequests: null });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let requests = [...res.data.data.items];
          let songbookPerformancesToBeDeleted = get().songbookPerformancesToBeDeleted;
          let newToBeDeleted = {};
          for (const [key, value] of Object.entries(songbookPerformancesToBeDeleted)) {
            let performanceIndex = requests.findIndex(x => x.unique_id === key);
            if (performanceIndex != -1) {
              newToBeDeleted[key] = value;
            }
          }
          set({ mySongRequestsDelivered: requests, songbookPerformancesToBeDeleted: newToBeDeleted });
        }
      })
      .catch(function () { });
  },
  getMySongRequestsPending: (sessionToken) => {


    MuvikaService.getMySongRequests(sessionToken, "pending")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          set({ mySongRequests: null });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let requests = [...res.data.data.items];
          set({ mySongRequestsPending: requests });
        }
      })
      .catch(function () { });
  },
  getPlayLists: (sessionToken, isWaiting = true) => {
    set({ isWaiting: isWaiting });
    MuvikaService.getPlayLists(sessionToken)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          set({ isSet: false, playLists: [], isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playLists = [...res.data.data.items];
          for (let i = 0; i < playLists.length; i++) {
            let duration = 0;
            for (let j = 0; j < playLists[i].items.length; j++) {
              playLists[i].items[j].position = j;
              playLists[i].items[j].incoming = duration;
              duration += playLists[i].items[j].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
          }
          set({ isSet: true, playLists: playLists, totalCount: res.data.data.items.length, isWaiting: false });
        }
      })
      .catch(function () { });
  },
  createPlayList: (sessionToken, playListName) => {
    MuvikaService.createPlayList(sessionToken, playListName)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          let playLists = get().playLists;
          if (playLists) {
            let playListIndex = playLists.findIndex(x => x.name === playListName);
            if (playListIndex != -1) {
              messageStore.getState().setError(sessionToken, res.data.error.code, TR.cm_same_playlist_exists_already);
            } else {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            }
          } else {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          }
        } else {
          get().getPlayLists(sessionToken);
        }
      });
  },
  deletePlayList: (sessionToken, playListId) => {


    MuvikaService.deletePlayList(sessionToken, playListId)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playLists = get().playLists;
          if (playLists) {
            let playListIndex = playLists.findIndex(x => x.id == playListId);
            if (playListIndex != -1) {
              playLists.splice(playListIndex, 1);
              set({ playLists: [...playLists] });
              messageStore.getState().setMessage(sessionToken, TR.cm_deleted_big);
            }
          }
        }
      })
      .catch(function () { });
  },
  setManual: (performance, isManual) => {
    if (isManual) {
      if (performance.flags) {
        if (!performance.flags.includes("manual")) {
          if (performance.flags.length > 0) {
            performance.flags += ",manual";
          } else {
            performance.flags = "manual";
          }
        }
      } else {
        performance.flags = "manual";
      }
      performance.isManual = true;
    } else {
      if (performance.flags) {
        performance.flags = performance.flags.replaceAll("manual", "");
        performance.flags = performance.flags.replaceAll(",,", ",");
      } else {
        performance.flags = "";
      }
      performance.isManual = false;
    }
    return performance;
  },
  getPlayQueue: (sessionToken) => {
    MuvikaService.getPlayQueue(sessionToken)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playQueue = { ...res.data.data };
          if (playQueue) {
            if (playQueue.items) {
              let duration = 0;
              for (let i = 0; i < playQueue.items.length; i++) {
                playQueue.items[i] = get().setManual(playQueue.items[i], playQueue.items[i].flags ? playQueue.items[i].flags.includes("manual") : false);
                playQueue.items[i].position = i;
                playQueue.items[i].incoming = duration;
                duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              if (playQueue.items.length > 0) {
                let currentPerformance = playQueue.items[0];
                let oldPlayQueue = get().playQueue;
                if (!oldPlayQueue) {
                  set({ isFirstPerformance: true });
                }
                set({ currentPerformance: currentPerformance });
              }
              set({ playQueue: playQueue, playQueueDuration: duration });
            }
          }
        }
      })
      .catch(function () { });
  },
  setCurrentPerformancePitch: (sessionToken, pitch) => {


    let currentPerformance = get().currentPerformance;
    let playQueue = get().playQueue;
    if (currentPerformance) {
      if (playQueue) {
        if (playQueue.items) {
          let performanceIndex = playQueue.items.findIndex(x => x.unique_id == currentPerformance.unique_id);
          if (performanceIndex != -1) {
            playQueue.items[performanceIndex].pitch = pitch;
          }
          get().setPlayList(sessionToken, playQueue);
        }
      }
      currentPerformance.pitch = pitch;
      set({ currentPerformance: { ...currentPerformance } });
    }
  },
  getHistory: (sessionToken) => {
    MuvikaService.getHistory(sessionToken)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let history = { ...res.data.data };
          console.log("history", history);
          if (history) {
            if (history.items) {
              for (let i = 0; i < history.items.length; i++) {
                history.items[i].position = i;
              }
              set({ history: history });
            }
          }
        }
      })
      .catch(function () { });
  },
  setCurrentPlayListPublic: (sessionToken, playList, profile) => {


    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    if (playList) {
      if (playList.items) {
        let duration = 0;
        let newItems = [];
        for (let i = 0; i < playList.items.length; i++) {
          let performance = {
            unique_id: generateId(8),
            created: dateNow,
            played: null,
            track: playList.items[i].track,
            position: i,
            incoming: duration,
            profile: profile,
            pitch: 0
          };
          duration += playList.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          newItems.push(performance);
        }
        let playQueue = get().playQueue;
        if (playQueue) {
          if (playList.items.length <= maxPlayQueueSize) {
            playQueue.items = newItems;
            set({ playQueueDuration: duration });
            MuvikaService.setPlayList(sessionToken, playQueue)
              .then(function (res) {
                if (res.data.error) {
                  messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                } else {
                  if (playQueue.items.length > 0) {
                    set({ currentPerformance: playQueue.items[0] });
                    if (get().nextPerformance) {
                      set({ nextPerformance: { ...playQueue.items[0] } });
                    }
                  }
                  set({ playQueue: { ...playQueue } });
                }
              })
              .catch(function () { });
          } else {
            messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
          }
        }
      }
    }
  },
  setCurrentPlayList: (sessionToken, playList) => {
    MuvikaService.getPlayList(sessionToken, playList)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playList = { ...res.data.data };
          let duration = 0;
          if (playList) {
            if (playList.items) {
              let dateNow = new Date();
              dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
              for (let i = 0; i < playList.items.length; i++) {
                playList.items[i].created = dateNow;
                playList.items[i].position = i;
                playList.items[i].incoming = duration;
                duration += playList.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              let playQueue = get().playQueue;
              if (playQueue) {
                if (playList.items.length <= maxPlayQueueSize) {
                  if (playList.items.length > 0) {
                    set({ currentPerformance: playList.items[0] });
                  }
                  playQueue.items = [...playList.items];
                  set({ playQueueDuration: duration, currentPlayList: playList });
                  MuvikaService.setPlayList(sessionToken, playQueue)
                    .then(function (res) {
                      if (res.data.error) {
                        messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                      } else {
                        set({ playQueue: { ...playQueue } });
                      }
                    })
                    .catch(function () { });
                } else {
                  messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
                }
              }
            }
          }
        }
      })
      .catch(function () { });
  },
  addPlayListToTheEndPublic: (sessionToken, playList, profile) => {
    if (playList) {
      if (playList.items) {
        let playQueue = get().playQueue;
        if (playQueue) {
          if (playQueue.items?.length + playList.items.length <= maxPlayQueueSize) {
            let dateNow = new Date();
            dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
            let newItems = [];
            for (let i = 0; i < playList.items.length; i++) {
              let performance = {
                unique_id: generateId(8),
                created: dateNow,
                played: null,
                track: playList.items[i].track,
                profile: profile,
                pitch: 0
              };
              newItems.push(performance);
            }
            playQueue.items.push(...newItems);
            let duration = 0;
            for (let i = 0; i < playQueue.items.length; i++) {
              playQueue.items[i].position = i;
              playQueue.items[i].incoming = duration;
              duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            if (playQueue.items.length > 0) {
              set({ currentPerformance: playQueue.items[0] });
              if (get().nextPerformance) {
                set({ nextPerformance: { ...playQueue.items[0] } });
              }
            }
            playQueue.items = [...playQueue.items];
            set({ playQueueDuration: duration });
            MuvikaService.setPlayList(sessionToken, playQueue)
              .then(function (res) {
                if (res.data.error) {
                  messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                } else {
                  set({ playQueue: { ...playQueue } });
                }
              })
              .catch(function () { });
          } else {
            messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
          }
        }
      }
    }
  },
  addPlayListToTheEnd: (sessionToken, playList) => {
    MuvikaService.getPlayList(sessionToken, playList)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playList = { ...res.data.data };
          if (playList) {
            if (playList.items) {
              let playQueue = get().playQueue;
              if (playQueue) {
                if (playQueue.items?.length + playList.items.length <= maxPlayQueueSize) {
                  let dateNow = new Date();
                  dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
                  for (let i = 0; i < playList.items.length; i++) {
                    playList.items[i].created = dateNow;
                    playList.items[i].unique_id = generateId(8);
                  }
                  playQueue.items.push(...playList.items);
                  let duration = 0;
                  for (let i = 0; i < playQueue.items.length; i++) {
                    playQueue.items[i].position = i;
                    playQueue.items[i].incoming = duration;
                    duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
                  }
                  if (playQueue.items.length > 0) {
                    set({ currentPerformance: playQueue.items[0] });
                    if (get().nextPerformance) {
                      set({ nextPerformance: { ...playQueue.items[0] } });
                    }
                  }
                  set({ playQueueDuration: duration });
                  playQueue.items = [...playQueue.items];
                  MuvikaService.setPlayList(sessionToken, playQueue)
                    .then(function (res) {
                      if (res.data.error) {
                        messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                      } else {
                        set({ playQueue: { ...playQueue } });
                      }
                    })
                    .catch(function () { });
                } else {
                  messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
                }
              }
            }
          }
        }
      })
      .catch(function () { });
  },
  setPlayList: (sessionToken, playList, sortSmartQ = false) => {
    console.log("setPlayList()", playList);
    const settings = settingsStore.getState().settings;
    if (settings) {
      if (settings.smartq_enabled == 1 && sortSmartQ) {
        playList = sortBySmartQ(playList, get().history);
      }
    }
    MuvikaService.setPlayList(sessionToken, playList)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ playQueue: { ...playList } });
        }
      })
      .catch(function () { });
  },
  clearHistory: (sessionToken) => {


    let history = get().history;
    history.items = [];
    get().setHistory(sessionToken, history);
  },
  setHistory: (sessionToken, history) => {
    MuvikaService.setHistory(sessionToken, history)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ history: { ...history } });
        }
      })
      .catch(function () { });
  },
  adjustHistorySize: (sessionToken, historySize) => {


    let history = get().history;
    if (history) {
      if (history.items) {
        history.items = history.items.slice(0, Math.min(history.items.length, historySize));
        get().setHistory(sessionToken, history);
      }
    }
  },
  addPerformanceToHistory: (sessionToken, performance) => {
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    let history = get().history;
    if (history) {
      if (history.items) {
        let newPerformance = {
          unique_id: generateId(8),
          created: dateNow,
          played: dateNow,
          pitch: performance.pitch,
          track: performance.track,
          profile: performance.profile
        };
        history.items.unshift(newPerformance);
        const settings = settingsStore.getState().settings;
        if (settings) {
          history.items = history.items.slice(0, Math.min(history.items.length, settings.history_size));
        }
        for (let i = 0; i < history.items.length; i++) {
          history.items[i].position = i;
        }
        get().setHistory(sessionToken, history);
      }
    }
  },
  prevFromHistory: (sessionToken) => {
    let history = get().history;
    console.log("history tr", history);
    let playQueue = get().playQueue;
    if (history && playQueue) {
      if (history.items) {
        if (history.items.length > 0) {
          let firstInHistory = history.items.shift();
          let dateNow = new Date();
          dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
          let performance = {
            unique_id: generateId(8),
            created: dateNow,
            played: null,
            pitch: firstInHistory.pitch,
            track: firstInHistory.track,
            profile: firstInHistory.profile
          };
          playQueue.items.unshift(performance);
          let duration = 0;
          for (let i = 0; i < playQueue.items.length; i++) {
            playQueue.items[i].position = i;
            playQueue.items[i].incoming = duration;
            duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          set({ playQueueDuration: duration });
          set({ currentPerformance: { ...playQueue.items[0] } });
          if (get().nextPerformance) {
            set({ nextPerformance: { ...playQueue.items[0] } });
          }
          for (let i = 0; i < history.items.length; i++) {
            history.items[i].position = i;
          }
          get().setPlayList(sessionToken, playQueue);
          get().setHistory(sessionToken, history);
        }
      }
    }
  },
  addPerformanceToPlayQueue: (sessionToken, track, singerProfile, pitch, toPos, isManual = false, playNow = false) => {
    let dateNow = new Date();
    const settings = settingsStore.getState().settings;
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    let performance = {
      unique_id: generateId(8),
      created: dateNow,
      played: null,
      pitch: pitch,
      track: track,
      profile: singerProfile,
      isManual: isManual ? isManual : false,
      flags: isManual ? "manual" : ""
    };
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        if (playQueue.items.length < maxPlayQueueSize) {
          console.log(toPos);
          if (toPos || toPos == 0) {
            if (playQueue.items.length > toPos && toPos >= 0) {
              playQueue.items.splice(toPos, 0, performance);
            } else {
              playQueue.items.push(performance);
            }
          } else {
            playQueue.items.push(performance);
          }
          let duration = 0;
          for (let i = 0; i < playQueue.items.length; i++) {
            playQueue.items[i].position = i;
            playQueue.items[i].incoming = duration;
            duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          set({ playQueueDuration: duration });
          if (settings) {
            if (settings.smartq_enabled == 1) {
              playQueue = sortBySmartQ(playQueue, get().history);
            } else {
              playQueue.items = [...playQueue.items];
            }
          } else {
            playQueue.items = [...playQueue.items];
          }
          MuvikaService.setPlayList(sessionToken, playQueue)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                if (toPos == 0 || !get().currentPerformance) {
                  set({ currentPerformance: playQueue.items[0], nextPerformance: null });
                }
                console.log("adding", toPos, playQueue.items, get().currentPerformance);
                console.log(toPos, playNow);
                if (toPos == 0 && playNow) {
                  playerStore.getState().setIsPlaying(true);
                  playerStore.getState().setIsStopped(false);
                } else if (toPos == 0 && !playNow) {
                  playerStore.getState().setIsPlaying(false);
                  playerStore.getState().setIsStopped(true);
                }
                set({ playQueue: { ...playQueue } });
              }
            })
            .catch(function () { });
        } else {
          messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
        }
      }
    }
  },
  editPerformanceInPlayList: (sessionToken, performanceId, singerProfile, pitch, playListId, pos = null) => {
    let playLists = get().playLists;
    let toPlayListId = playLists.findIndex(x => x.id == playListId);
    let toPlayList = playLists[toPlayListId];
    if (toPlayList) {
      if (toPlayList.items) {
        let performanceListId = toPlayList.items.findIndex(x => x.unique_id == performanceId);
        let performance = toPlayList.items[performanceListId];
        if (performance) {
          performance.profile = singerProfile;
          performance.pitch = pitch;
          toPlayList.items[performanceListId] = performance;
          if (pos || pos == 0) {
            if (pos < toPlayList.items.length) {
              performance.position = pos;
              toPlayList.items.splice(performanceListId, 1);
              toPlayList.items.splice(pos, 0, { ...performance });
              let duration = 0;
              for (let i = 0; i < toPlayList.items.length; i++) {
                toPlayList.items[i].position = i;
                toPlayList.items[i].incoming = duration;
                duration += toPlayList.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
            }
          }
          MuvikaService.setPlayList(sessionToken, toPlayList)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                messageStore.getState().setMessage(sessionToken, TR.cm_saved);
                set({ playLists: [...playLists] });
              }
            })
            .catch(function () { });
        }
      }
    }
  },
  addPerformanceToPlayList: (sessionToken, track, singerProfile, pitch, playListId, pos = null) => {
    console.log("playList");
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    let performance = {
      unique_id: generateId(8),
      created: dateNow,
      played: null,
      pitch: pitch,
      track: track,
      profile: singerProfile
    };
    let toPlayListId = get().playLists.findIndex(x => x.id == playListId);
    let playLists = get().playLists;
    let toPlayList = playLists[toPlayListId];
    if (toPlayList) {
      if (toPlayList.items) {
        if (toPlayList.items.length < maxPlayQueueSize) {
          let duration = 0;
          if (pos || pos == 0) {
            if (pos < toPlayList.items.length) {
              performance.position = pos;
              toPlayList.items.splice(pos, 0, { ...performance });
            } else {
              toPlayList.items.push({ ...performance });
            }
          } else {
            toPlayList.items.push({ ...performance });
          }
          for (let i = 0; i < toPlayList.items.length; i++) {
            toPlayList.items[i].position = i;
            toPlayList.items[i].incoming = duration;
            duration += toPlayList.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          toPlayList.items = toPlayList.items;
          playLists[toPlayListId] = { ...toPlayList };
          MuvikaService.setPlayList(sessionToken, toPlayList)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                messageStore.getState().setMessage(sessionToken, TR.cm_added);
                set({ playLists: [...playLists] });
              }
            })
            .catch(function () { });
        } else {
          messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
        }
      }
    }
  },
  addPerformanceFromSongbook: async (sessionToken, sbPerformance, toPos) => {
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    let performance = {
      unique_id: sbPerformance.unique_id,
      created: dateNow,
      played: null,
      pitch: sbPerformance.pitch,
      track: sbPerformance.track,
      profile: sbPerformance.profile,
      isManual: toPos || toPos == 0 ? true : false,
      flags: toPos || toPos == 0 ? "manual" : ""
    };
    console.log("inserting performance songbook", performance);
    console.log("adding performance from songbook", performance.isManual);
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        if (playQueue.items.length < maxPlayQueueSize) {
          if (toPos || toPos == 0) {
            if (playQueue.items.length > toPos && toPos >= 0) {
              playQueue.items.splice(toPos, 0, performance);
            } else {
              playQueue.items.push(performance);
            }
          } else {
            playQueue.items.push(performance);
          }
          let duration = 0;
          for (let i = 0; i < playQueue.items.length; i++) {
            playQueue.items[i].position = i;
            playQueue.items[i].incoming = duration;
            duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          set({ playQueueDuration: duration });
          const settings = settingsStore.getState().settings;
          if (settings) {
            if (settings.smartq_enabled == 1) {
              playQueue = sortBySmartQ(playQueue, get().history);
            } else {
              playQueue.items = [...playQueue.items];
            }
          } else {
            playQueue.items = [...playQueue.items];
          }
          let res = await MuvikaService.setPlayList(sessionToken, playQueue);
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (!get().currentPerformance) {
              if (playQueue.items.length > 0) {
                set({ currentPerformance: playQueue.items[0] });
              }
            }
            set({ playQueue: { ...playQueue } });
          }
        } else {
          messageStore.getState().setError(sessionToken, 0, TR.cm_max_number_of_songs_reached);
        }
      }
    }
  },
  getNextPerformance: () => {
    let playQueue = get().playQueue;
    if (playQueue) {
      let currentPosition = get().currentPosition;
      let nextPerformance = playQueue.items[currentPosition];
      if (nextPerformance) {
        set({ currentPerformance: nextPerformance });
        return nextPerformance;
      }
    }
  },
  setCurrentPosition: (pos, performance) => {


    set({ currentPosition: pos, currentPerformance: performance });
  },
  getPerformancePosition: (performanceId) => {


    let performancePosition = -1;
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        for (let i = 0; i < performances.length; i++) {
          let performance = performances[i];
          if (performance.unique_id === performanceId) {
            performancePosition = i;
            break;
          }
        }
      }
    }
    return performancePosition;
  },
  getPerformancePositionPlayList: (performanceId, playList) => {


    let performancePosition = -1;
    if (playList) {
      if (playList.items) {
        let performances = playList.items;
        for (let i = 0; i < performances.length; i++) {
          let performance = performances[i];
          if (performance.unique_id === performanceId) {
            performancePosition = i;
            break;
          }
        }
      }
    }
    return performancePosition;
  },
  swapPerformances: (sessionToken, performanceId1, performanceId2) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        //console.log(playQueue.items);
        let performancePosition1 = get().getPerformancePosition(performanceId1);
        let performancePosition2 = get().getPerformancePosition(performanceId2);
        if (performancePosition1 != -1 && performancePosition2 != -1) {
          var performance1 = { ...playQueue.items[performancePosition1] };
          var performance2 = { ...playQueue.items[performancePosition2] };
          performance1.position = performancePosition2;
          performance2.position = performancePosition1;
          playQueue.items[performancePosition1] = performance2;
          playQueue.items[performancePosition2] = performance1;
          if (performancePosition1 == 0 || performancePosition2 == 0) {
            IntervalService.clearAllIntervals();
            set({ currentPerformance: { ...playQueue.items[0] } });
            if (get().nextPerformance) {
              set({ nextPerformance: { ...playQueue.items[0] } });
            }
          }
          //console.log(playQueue.items);
          get().setPlayList(sessionToken, playQueue);
        }
      }
    }
  },
  movePerformanceInPlayList: (sessionToken, playListId, positionA, positionB) => {
    let playLists = get().playLists;
    let playListListId = playLists.findIndex(x => x.id == playListId);
    let playList = playLists[playListListId];
    if (playList) {
      if (playList.items) {
        let performances = playList.items;
        if (performances.length > positionA && performances.length > positionB) {
          let performanceA = { ...performances[positionA] };
          performances.splice(positionA, 1);
          performances.splice(positionB, 0, performanceA);
          let duration = 0;
          for (let i = 0; i < performances.length; i++) {
            performances[i].position = i;
            performances[i].incoming = duration;
            duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          playList.items = performances;
          MuvikaService.setPlayList(sessionToken, playList)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                set({ playLists: [...playLists] });
              }
            })
            .catch(function () { });
        }
      }
    }
  },
  movePerformance: (sessionToken, positionA, positionB) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        if (performances.length > positionA && performances.length > positionB) {
          let performanceA = { ...performances[positionA] };
          const settings = settingsStore.getState().settings;
          if (settings) {
            if (settings.smartq_enabled == 1) {
              performanceA = get().setManual(performanceA, true);
            }
          }
          performances.splice(positionA, 1);
          performances.splice(positionB, 0, performanceA);
          let duration = 0;
          for (let i = 0; i < performances.length; i++) {
            performances[i].position = i;
            performances[i].incoming = duration;
            duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          set({ playQueueDuration: duration });
          playQueue.items = performances;
          if (positionA == 0 || positionB == 0) {
            IntervalService.clearAllIntervals();
            set({ currentPerformance: { ...playQueue.items[0] } });
            if (get().nextPerformance) {
              set({ nextPerformance: { ...playQueue.items[0] } });
            }
          }
          get().setPlayList(sessionToken, playQueue);
        }
      }
    }
  },
  moveToSecond: (sessionToken, performanceId) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let performance = performances[performancePosition];
          if (performancePosition != 1) {
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                performance = get().setManual(performance, true);
              }
            }
            performances.splice(performancePosition, 1);
            performances = [
              ...performances.slice(0, 1),
              performance,
              ...performances.slice(1)
            ];
            let duration = 0;
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            set({ playQueueDuration: duration });
            playQueue.items = performances;
            if (performancePosition == 0) {
              IntervalService.clearAllIntervals();
              set({ currentPerformance: { ...playQueue.items[0] } });
              if (get().nextPerformance) {
                set({ nextPerformance: { ...playQueue.items[0] } });
              }
            }
            get().setPlayList(sessionToken, playQueue);
          }
        }
      }
    }
  },
  moveToTop: (sessionToken, performanceId) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let performance = performances[performancePosition];
          if (performancePosition > 0) {
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                performance = get().setManual(performance, true);
              }
            }
            performances.splice(performancePosition, 1);
            performances.unshift(performance);
            let duration = 0;
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            set({ playQueueDuration: duration });
            playQueue.items = performances;
            IntervalService.clearAllIntervals();
            set({ currentPerformance: performance });
            if (get().nextPerformance) {
              set({ nextPerformance: { ...performance } });
            }
            get().setPlayList(sessionToken, playQueue);
          }
        }
      }
    }
  },
  moveToBottom: (sessionToken, performanceId) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let performance = performances[performancePosition];
          if (performancePosition >= 0) {
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                performance = get().setManual(performance, true);
              }
            }
            performances.splice(performancePosition, 1);
            performances.push(performance);
            let duration = 0;
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            set({ playQueueDuration: duration });
            playQueue.items = performances;
            if (performancePosition == 0) {
              IntervalService.clearAllIntervals();
              set({ currentPerformance: { ...playQueue.items[0] } });
              if (get().nextPerformance) {
                set({ nextPerformance: { ...playQueue.items[0] } });
              }
            }
            get().setPlayList(sessionToken, playQueue);
          }
        }
      }
    }
  },
  moveUp: (sessionToken, performanceId) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let performance = performances[performancePosition];
          if (performancePosition > 0) {
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                performance = get().setManual(performance, true);
              }
            }
            performances.splice(performancePosition, 1);
            performances.splice(performancePosition - 1, 0, performance);
            let duration = 0;
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            set({ playQueueDuration: duration });
            playQueue.items = performances;
            if (performancePosition == 0 || performancePosition - 1 == 0) {
              IntervalService.clearAllIntervals();
              set({ currentPerformance: { ...playQueue.items[0] } });
              if (get().nextPerformance) {
                set({ nextPerformance: { ...playQueue.items[0] } });
              }
            }
            get().setPlayList(sessionToken, playQueue);
          }
        }
      }
    }
  },
  moveDown: (sessionToken, performanceId) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let performance = performances[performancePosition];
          if (performancePosition < performances.length - 1) {
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                performance = get().setManual(performance, true);
              }
            }
            performances.splice(performancePosition, 1);
            performances.splice(performancePosition + 1, 0, performance);
            let duration = 0;
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            set({ playQueueDuration: duration });
            playQueue.items = performances;
            if (performancePosition == 0) {
              IntervalService.clearAllIntervals();
              set({ currentPerformance: { ...playQueue.items[0] } });
              if (get().nextPerformance) {
                set({ nextPerformance: { ...playQueue.items[0] } });
              }
            }
            get().setPlayList(sessionToken, playQueue);
          }
        }
      }
    }
  },
  moveUpInPlayList: (sessionToken, playListId, performanceId) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let performance = performances[performancePosition];
            if (performancePosition > 0) {
              performances.splice(performancePosition, 1);
              performances.splice(performancePosition - 1, 0, performance);
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              playList.items = performances;
              MuvikaService.setPlayList(sessionToken, playList)
                .then(function (res) {
                  if (res.data.error) {
                    messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                  } else {
                    set({ playLists: [...playLists] });
                  }
                })
                .catch(function () { });
            }
          }
        }
      }
    }
  },
  moveDownInPlayList: (sessionToken, playListId, performanceId) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let performance = performances[performancePosition];
            if (performancePosition < performances.length - 1) {
              performances.splice(performancePosition, 1);
              performances.splice(performancePosition + 1, 0, performance);
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              playList.items = performances;
              MuvikaService.setPlayList(sessionToken, playList)
                .then(function (res) {
                  if (res.data.error) {
                    messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                  } else {
                    set({ playLists: [...playLists] });
                  }
                })
                .catch(function () { });
            }
          }
        }
      }
    }
  },
  moveToSecondInPlayList: (sessionToken, playListId, performanceId) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let performance = performances[performancePosition];
            if (performancePosition >= 0) {
              performances.splice(performancePosition, 1);
              performances.splice(1, 0, performance);
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              playList.items = performances;
              MuvikaService.setPlayList(sessionToken, playList)
                .then(function (res) {
                  if (res.data.error) {
                    messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                  } else {
                    set({ playLists: [...playLists] });
                  }
                })
                .catch(function () { });
            }
          }
        }
      }
    }
  },
  moveToTopInPlayList: (sessionToken, playListId, performanceId) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let performance = performances[performancePosition];
            if (performancePosition > 0) {
              performances.splice(performancePosition, 1);
              performances.unshift(performance);
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              playList.items = performances;
              MuvikaService.setPlayList(sessionToken, playList)
                .then(function (res) {
                  if (res.data.error) {
                    messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                  } else {
                    set({ playLists: [...playLists] });
                  }
                })
                .catch(function () { });
            }
          }
        }
      }
    }
  },
  moveToBottomInPlayList: (sessionToken, playListId, performanceId) => {


    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let performance = performances[performancePosition];
            if (performancePosition >= 0) {
              performances.splice(performancePosition, 1);
              performances.push(performance);
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
              playList.items = performances;
              MuvikaService.setPlayList(sessionToken, playList)
                .then(function (res) {
                  if (res.data.error) {
                    messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                  } else {
                    set({ playLists: [...playLists] });
                  }
                })
                .catch(function () { });
            }
          }
        }
      }
    }
  },
  setPlayIsOn: (isOn) => {


    set({ isOn: isOn });
  },
  addSongbookId: (id) => {


    let songbookIds = get().songbookIds;
    if (songbookIds) {
      songbookIds.push(id);
    }
  },
  clearPlayQueue: (sessionToken) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      playQueue.items = [];
      set({ playQueueDuration: 0, currentPerformance: null });
      get().setPlayList(sessionToken, playQueue);
    }
  },
  clearHistory: (sessionToken) => {
    let history = get().history;
    if (history) {
      history.items = [];
      get().setHistory(sessionToken, history);
    }
  },
  clearPlayQueueSongbook: (sessionToken) => {


    let playQueue = get().playQueue;
    if (playQueue) {
      MuvikaService.createSongRequest(sessionToken, "clear", null, null, null, [])
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          }
        })
        .catch(function () { });
    }
  },
  deletePerformance: (sessionToken, performanceId) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performancePosition = get().getPerformancePosition(performanceId);
        if (performancePosition != -1) {
          let duration = 0;
          performances.splice(performancePosition, 1);
          for (let i = 0; i < performances.length; i++) {
            performances[i].position = i;
            performances[i].incoming = duration;
            duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
          }
          set({ playQueueDuration: duration });
          playQueue.items = performances;
          if (playQueue.items.length == 0) {
            set({ currentPerformance: null });
          } else {
            set({ currentPerformance: playQueue.items[0] });
            if (get().nextPerformance) {
              set({ nextPerformance: { ...playQueue.items[0] } });
            }
          }
          get().setPlayList(sessionToken, playQueue);
        }
      }
    }
  },
  deletePerformanceInPlayList: (sessionToken, playListId, performanceId) => {
    let playLists = get().playLists;
    if (playLists) {
      let playListIndex = playLists.findIndex(x => x.id == playListId);
      if (playListIndex != -1) {
        let playList = playLists[playListIndex];
        if (playList.items) {
          let performances = playList.items;
          let performancePosition = get().getPerformancePositionPlayList(performanceId, playList);
          if (performancePosition != -1) {
            let duration = 0;
            performances.splice(performancePosition, 1);
            for (let i = 0; i < performances.length; i++) {
              performances[i].position = i;
              performances[i].incoming = duration;
              duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
            playList.items = performances;
            MuvikaService.setPlayList(sessionToken, playList)
              .then(function (res) {
                if (res.data.error) {
                  messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                } else {
                  set({ playLists: [...playLists] });
                }
              })
              .catch(function () { });
          }
        }
      }
    }
  },
  deletePerformanceFromHistory: (sessionToken, performanceId) => {


    let history = get().history;
    if (history) {
      if (history.items) {
        let performances = history.items;
        let performancePosition = get().getPerformancePositionPlayList(performanceId, history);
        //console.log(performancePosition);
        if (performancePosition != -1) {
          performances.splice(performancePosition, 1);
          for (let i = 0; i < performances.length; i++) {
            performances[i].position = i;
          }
          history.items = performances;
          get().setHistory(sessionToken, history);
        }
      }
    }
  },
  editPerformance: (sessionToken, performanceId, singer, pitch, track = null, pos = null, isManual = null, playNow = false) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performances = playQueue.items;
        let performanceIndex = performances.findIndex(x => x.unique_id == performanceId);
        let performance = performances[performanceIndex];
        let oldPos = performance.position;
        if (performance) {
          performance = get().setManual(performance, isManual);
          //performance.unique_id = generateId(8);
          performance.profile = singer;
          performance.pitch = pitch;
          if (track) {
            if (performance.track.track_id === track.track_id) {
              performance.track = track;
            } else {
              performance.track = track;
            }
            if (performance.flags) {
              if (performance.flags.length > 0) {
                performance.flags += " track_changed";
              } else {
                performance.flags = "track_changed";
              }
            } else {
              performance.flags = "track_changed";
            }
          }
          performances[performanceIndex] = performance;
          if (pos == -2) {
            performances[performanceIndex] = get().setManual(performances[performanceIndex], false);
            const settings = settingsStore.getState().settings;
            if (settings) {
              if (settings.smartq_enabled == 1) {
                playQueue = sortBySmartQ(playQueue, get().history);
              } else {
                playQueue.items = [...playQueue.items];
              }
            } else {
              playQueue.items = [...playQueue.items];
            }
          } else if (pos || pos == 0) {
            if (pos >= 0 && pos < performances.length) {
              performance.position = pos;
              performances.splice(performanceIndex, 1);
              performances.splice(pos, 0, { ...performance });
              let duration = 0;
              for (let i = 0; i < performances.length; i++) {
                performances[i].position = i;
                performances[i].incoming = duration;
                duration += performances[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
              }
            }
          }
        }
        playQueue.items = [...performances];
        set({ playQueue: { ...playQueue } });
        console.log("editPerformance", playQueue);
        MuvikaService.setPlayList(sessionToken, playQueue)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              if (oldPos == 0 || performance.position == 0) {
                console.log("setting current performance");
                set({ currentPerformance: { ...performances[0] }, nextPerformance: null });
              }
              if (performance.position == 0 && playNow) {
                console.log("editPerformance", performance.position, playNow);
                playerStore.getState().setIsPlaying(true);
                playerStore.getState().setIsStopped(false);
              }
              if (oldPos == 0 || performance.position == 0) {
                console.log("setting current performance");
                set({ currentPerformance: { ...performances[0] }, nextPerformance: null });
              }
              set({ playQueue: { ...playQueue } });
            }
          })
          .catch(function () { });
      }
    }
  },
  editPerformancePlayList: (sessionToken, playListId, performanceId, singer, pitch, track = null) => {
    let playLists = get().playLists;
    let playListIndex = playLists.findIndex(x => x.id == playListId);
    let playList = playLists[playListIndex];
    if (playList) {
      if (playList.items) {
        let performances = playList.items;
        let performanceIndex = performances.findIndex(x => x.unique_id == performanceId);
        let performance = performances[performanceIndex];
        if (performance) {
          performance.profile = singer;
          performance.pitch = pitch;
          if (track) {
            performance.track = track;
          }
          performances[performanceIndex] = performance;
          playList.items = performances;
          get().setPlayList(sessionToken, playList);
          playLists[playListIndex] = playList;
          set({ playLists: [...playLists] });
        }
      }
    }
  },
  setPerformanceToBeChanged: (performance) => {
    set({ performanceToBeChanged: performance });
  },
  changeTrackPerformance: (sessionToken, track, singerProfile, pitch) => {
    let playQueue = get().playQueue;
    if (playQueue) {
      if (playQueue.items) {
        let performanceToBeChanged = get().performanceToBeChanged;
        if (performanceToBeChanged) {
          performanceToBeChanged.unique_id = generateId(8);
          performanceToBeChanged.track = track;
          performanceToBeChanged.pitch = pitch;
          performanceToBeChanged.profile = singerProfile;
          playQueue.items[performanceToBeChanged.position] = performanceToBeChanged;
          if (performanceToBeChanged.position == 0) {
            set({ currentPerformance: { ...performanceToBeChanged } });
          }
          set({ performanceToBeChanged: null });
          get().setPlayList(sessionToken, playQueue);
        }
      }
    }
  }
})));

export default performanceStore;